import React from 'react'
import PropTypes from 'prop-types'
import { IconFAWrapper } from './IconFAWrapper'

export const IconFABars = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconFAWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg
        aria-hidden='true'
        focusable='false'
        data-prefix='fas'
        data-icon='bars'
        role='img'
        viewBox='0 0 448 512'
      >
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          d='M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z'
        />
      </svg>
    </IconFAWrapper>
  )
}

IconFABars.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
